import { TableRow, TableCell, ListItemText, MenuItem, IconButton, Avatar } from '@mui/material';
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
// types
import { HTTaiKhoan, OptionModel } from 'src/types/api-response';
import { useBoolean } from 'src/hooks/use-boolean';
import AccountChangePasswordDialog from './account-change-password-dialog';

type Props = {
  row: HTTaiKhoan;
  selected: boolean;
  onEditRow: VoidFunction;
  // Nhận thêm danh sách options để mapping
  statusOptions?: OptionModel[]; 
};

export default function AccountTableRow({ row, selected, onEditRow, statusOptions = [] }: Props) {
  const { tenTaiKhoan, email, sdt, trangThai } = row;
  
  const popover = usePopover();
  const changePassword = useBoolean();

  // Hàm helper để lấy Label từ ID trạng thái
  const getStatusLabel = (statusId: number) => {
    // Tìm trong danh sách options trả về từ API 
    const found = statusOptions.find(opt => Number(opt.value || "0") === statusId); // Lưu ý kiểu dữ liệu id (number/string) phải khớp
    if (found) return found.text;
    
    return statusId === 1 ? 'Đang dùng' : 'Tạm ngưng';
  };

  // Hàm helper lấy màu sắc (có thể logic riêng hoặc dựa trên tên)
  const getStatusColor = (statusId: number) => 
    // Giả định: 1 là Active -> success, còn lại -> error/default
     statusId === 1 ? 'success' : 'error'
  ;

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar alt={tenTaiKhoan || ''} sx={{ mr: 2 }}>
            {tenTaiKhoan?.charAt(0).toUpperCase()}
          </Avatar>
          <ListItemText
            primary={tenTaiKhoan}
            secondary={email}
            primaryTypographyProps={{ typography: 'body2' }}
            secondaryTypographyProps={{ component: 'span', color: 'text.disabled' }}
          />
        </TableCell>

        <TableCell>{email}</TableCell>

        <TableCell>{sdt || '---'}</TableCell>

        <TableCell>
          {/* Hiển thị trạng thái động từ API Options */}
          <Label variant="soft" color={getStatusColor(trangThai)}>
            {getStatusLabel(trangThai)}
          </Label>
        </TableCell>

        <TableCell align="right">
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <CustomPopover open={popover.open} onClose={popover.onClose} arrow="right-top">
        <MenuItem
          onClick={() => {
            onEditRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" /> Sửa
        </MenuItem>

        <MenuItem
          onClick={() => {
            changePassword.onTrue();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:key-bold" /> 
          Cập nhật mật khẩu
        </MenuItem>
      </CustomPopover>

      <AccountChangePasswordDialog
        open={changePassword.value}
        onClose={changePassword.onFalse}
        account={row}
      />
    </>
  );
}